import React from "react";
import {StyledMainContainer} from "../Main/index.styles";
import {Section10, Section7} from "../../components";

export const Contacts = () => {

    return(
        <StyledMainContainer>
            <Section10/>
            <Section7 />
        </StyledMainContainer>
    )
}